import { Directive, Input, OnInit, inject } from '@angular/core';

import { ThemeOptions, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsButtonIcon, DsButtonIconKind, DsButtonIconSizes, DsButtonIconVariant } from '@frontend/ui/button-icon';

@Directive({
    selector: '[msThemedIconButton]',
})
export class SportsThemedIconButtonDirective implements OnInit {
    DsButtonIcon = inject(DsButtonIcon, { self: true });
    currentTheme = injectCurrentTheme();

    @Input() themeKind: ThemeOptions<DsButtonIconKind> = {};
    @Input() themeVariant: ThemeOptions<DsButtonIconVariant> = {};
    @Input() themeSize: ThemeOptions<DsButtonIconSizes> = {};
    @Input() themeInverse: ThemeOptions<boolean> = {};

    ngOnInit() {
        const kind = this.themeKind[this.currentTheme];
        const variant = this.themeVariant[this.currentTheme];
        const size = this.themeSize[this.currentTheme];
        const inverse = this.themeInverse[this.currentTheme];

        if (kind) {
            this.DsButtonIcon.kind.set(kind);
        }

        if (variant) {
            this.DsButtonIcon.variant.set(variant);
        }

        if (size) {
            this.DsButtonIcon.size.set(size);
        }

        if (inverse) {
            this.DsButtonIcon.inverse.set(inverse);
        }
    }
}
